import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BasePreviewComponent } from '../base-preview.component';

@Component({
    selector: 'app-pdf-preview',
    templateUrl: './pdf-preview.component.html',
    styleUrls: ['./pdf-preview.component.scss'],
    standalone: false
})
export class PdfPreviewComponent extends BasePreviewComponent {
  // PDF State
  isLoading = true;
  currentPage = 1;

  constructor(
    public override dialogRef: MatDialogRef<PdfPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public override data: any,
    private sanitizer: DomSanitizer
  ) {
    super(dialogRef, data);
  }

  // ========================================
  // PDF URL Handling
  // ========================================

  /**
   * Get PDF URL with fragment parameters for page navigation
   * Browser's PDF viewer respects #page parameter for initial load
   */
  getPdfUrl(): SafeResourceUrl {
    const url = this.getMediaUrl();
    // Use fragments to control PDF viewer (no query params to avoid cache issues)
    const urlWithFragment = `${url}#toolbar=0&navpanes=0&page=${this.currentPage}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(urlWithFragment);
  }

  /**
   * Called when iframe finishes loading
   */
  onLoad(): void {
    this.isLoading = false;
  }

  // ========================================
  // Navigation Controls
  // ========================================

  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage(): void {
    this.currentPage++;
  }

  goToPage(page: number): void {
    if (page >= 1) {
      this.currentPage = page;
    }
  }

  // ========================================
  // Print
  // ========================================

  printPdf(): void {
    const url = this.getMediaUrl();
    const printWindow = window.open(url, '_blank');
    if (printWindow) {
      printWindow.addEventListener('load', () => {
        printWindow.print();
      });
    }
  }
}
